import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import "./game.css";

function Sicbo() {
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    return (
        <>
            {loading == true ? (
                <div className="loading">
                    <div className="loader"></div>
                </div>
            ) : null}
            <div className="banner-game">
                <img src={require("../../image/taixiu.png")} />
            </div>
            <div className="container">
                <div className="menu-box-game" style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr" }}>
                    <div className="box-game">
                        <div className="box-game-image">
                            <img src={require("../../images/mb75s.png")} />
                        </div>
                        <div className="box-game-play" onClick={() => navigate("/xs75s/lo2")}>
                            <span className="box-game-start">Chơi ngay</span>
                        </div>
                    </div>
                    <div className="box-game">
                        <div className="box-game-image">
                            <img src={require("../../images/st2p.png")} />
                        </div>
                        <div className="box-game-play" onClick={() => navigate("/xs120s/lo2")}>
                            <span className="box-game-start">Chơi ngay</span>
                        </div>
                    </div>
                    <div className="box-game">
                        <div className="box-game-image">
                            <img src={require("../../images/xd45s.png")} />
                        </div>
                        <div className="box-game-play" onClick={() => navigate("/xd45s")}>
                            <span className="box-game-start">Chơi ngay</span>
                        </div>
                    </div>
                    <div className="box-game">
                        <div className="box-game-image">
                            <img src={require("../../images/xd1p.png")} />
                        </div>
                        <div className="box-game-play" onClick={() => navigate("/xd60s")}>
                            <span className="box-game-start">Chơi ngay</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Sicbo;
